import * as React from 'react'

import type { Form } from 'factorial-form'

import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import TextArea from 'modules/core/components/Inputs/TextArea'
import i18n from 'modules/core/lib/i18n'

interface Props {
  form: Form
}

export default function GroupForm({ form }: Props) {
  return (
    <>
      <FormRow>
        <Text
          mandatory
          field={form.get('title')}
          label={i18n.t('dashboard.groups.new.labels.title')}
        />
      </FormRow>
      <FormRow>
        <TextArea
          mandatory
          field={form.get('description')}
          label={i18n.t('dashboard.groups.new.labels.description')}
        />
      </FormRow>
    </>
  )
}
